<div class="landing2">
  <div id="app" class="section">
    <div class="container hero-container w-container">
      <div class="div-block-8">
        <h1 data-w-id="4fb8184b-95af-b21b-c77f-3dbfd563e4da" style="opacity:0" class="heading-14">Compra <span data-w-id="f5035e3d-135d-67f3-9a06-213335d280f1" style="opacity:0">criptomonedas en tu propia </span><span data-w-id="e4527160-92da-a620-f273-64e10601c2eb" style="opacity:0">wallet.</span></h1>
        <div id="w-node-_43184afc-6125-a8d5-d42c-ce29ee66b766-abadb6b4" data-w-id="43184afc-6125-a8d5-d42c-ce29ee66b766" style="opacity:0" class="app_container">
          <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100" class="tabs-2 w-tabs">
            <div class="tabs-menu w-tab-menu">
              <a data-w-tab="Tab 1" class="tab-link w-inline-block w-tab-link w--current">
                <div class="div-block-10"><img loading="lazy" src="/assets/landings/images/buy.svg" alt="" class="tab-img">
                  <div class="tab-text">Comprar</div>
                </div>
              </a>
              <a data-w-tab="Tab 2" class="tab-link not-active w-inline-block w-tab-link">
                <div class="div-block-10"><img loading="lazy" src="/assets/landings/images/sell.svg" alt="" class="tab-img">
                  <div class="tab-text">Vender</div>
                </div>
              </a>
            </div>
            <div class="tabs-content w-tab-content">
              <div data-w-tab="Tab 1" class="w-tab-pane w--tab-active">
                <div class="form-block-3 w-form">
                  <form id="wf-form-Operation-selector" name="wf-form-Operation-selector" data-name="Operation-selector" method="get" class="form grid-3" data-wf-page-id="661c0888a66a1feeabadb6b4" data-wf-element-id="b16ddf08-813e-8869-ebb5-7e91c844aa73">
                    <div data-w-id="ed4dff6b-0eaa-6c99-d63c-7169a7de5719" style="opacity:0" class="wrapper">
                      <div class="div-block-147">
                        <div class="label">Vas a pagar</div>
                        <div class="div-block-11"><input class="input input_home w-input" maxlength="256" name="buy-fiat-qt-selector" data-name="buy-fiat-qt-selector" placeholder="0" type="text" id="buy-fiat-qt-selector" required=""></div>
                        <div class="offer-flair">+5€ gratis <span class="text-span-17"></span></div>
                        <div class="offer-flair-wrapper-helper"></div>
                      </div>
                      <div>
                        <div class="symbol_selector">
                          <div class="div-block-140"><img loading="lazy" src="/assets/landings/images/eur.svg" alt=""></div>
                          <div class="text-block-79">Euros<span class="text-span-15"></span></div>
                        </div>
                      </div>
                    </div>
                    <div data-w-id="a83239ff-3cdd-8c81-d883-070360da2fa4" style="opacity:0" class="wrapper">
                      <div>
                        <div class="label">Vas a recibir</div>
                        <div class="div-block-11"><input class="input input_home w-input" maxlength="256" name="buy-fiat-qt-selector-2" data-name="Buy Fiat Qt Selector 2" placeholder="0" type="text" id="buy-fiat-qt-selector-2" required=""></div>
                        <div class="div-block-146">1 Bitcoin = 71.543,26€</div>
                        <div class="input-price-reference-wrapp-helper"></div>
                      </div>
                      <div>
                        <div class="symbol_selector">
                          <div class="div-block-140"><img loading="lazy" src="/assets/landings/images/btc.svg" alt=""></div>
                          <div class="text-block-79">Bitcoin<span class="text-span-15"></span></div>
                        </div>
                      </div>
                    </div>
                    <div class="separator_arrow">
                      <div class="text-block-6"></div>
                    </div>
                  </form>
                  <div class="success-message w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div class="error-message w-form-fail">
                    <div>error-message</div>
                  </div>
                </div>
              </div>
              <div data-w-tab="Tab 2" class="w-tab-pane">
                <div class="form-block-3 w-form">
                  <form id="wf-form-Operation-selector" name="wf-form-Operation-selector" data-name="Operation-selector" method="get" class="form grid-3" data-wf-page-id="661c0888a66a1feeabadb6b4" data-wf-element-id="8286ec0c-a297-1b20-adb1-f7f936d6c242">
                    <div data-w-id="8286ec0c-a297-1b20-adb1-f7f936d6c243" style="opacity:0" class="wrapper">
                      <div class="div-block-147">
                        <div class="label">Vas a pagar</div>
                        <div class="div-block-11"><input class="input input_home w-input" maxlength="256" name="buy-fiat-qt-selector-3" data-name="Buy Fiat Qt Selector 3" placeholder="0" type="text" id="buy-fiat-qt-selector-3" required=""></div>
                        <div class="offer-flair">+5€ gratis <span class="text-span-17"></span></div>
                        <div class="offer-flair-wrapper-helper"></div>
                      </div>
                      <div>
                        <div class="symbol_selector">
                          <div class="div-block-140"><img loading="lazy" src="/assets/landings/images/eur.svg" alt=""></div>
                          <div class="text-block-79">Euros<span class="text-span-15"></span></div>
                        </div>
                      </div>
                    </div>
                    <div data-w-id="8286ec0c-a297-1b20-adb1-f7f936d6c256" style="opacity:0" class="wrapper">
                      <div>
                        <div class="label">Vas a recibir</div>
                        <div class="div-block-11"><input class="input input_home w-input" maxlength="256" name="buy-fiat-qt-selector-2" data-name="Buy Fiat Qt Selector 2" placeholder="0" type="text" id="buy-fiat-qt-selector-2" required=""></div>
                        <div class="div-block-146">1 Bitcoin = 71.543,26€</div>
                        <div class="input-price-reference-wrapp-helper"></div>
                      </div>
                      <div>
                        <div class="symbol_selector">
                          <div class="div-block-140"><img loading="lazy" src="/assets/landings/images/btc.svg" alt=""></div>
                          <div class="text-block-79">Bitcoin<span class="text-span-15"></span></div>
                        </div>
                      </div>
                    </div>
                    <div class="separator_arrow">
                      <div class="text-block-6"></div>
                    </div>
                  </form>
                  <div class="success-message w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div class="error-message w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a href="step-1a.html" class="nav-link-special form-btn w-inline-block">
            <div class="text-block-10"><span class="navbar_icons"></span></div>
            <div class="text-block-11">Comprar Bitcoin</div>
          </a>
        </div>
        <div data-w-id="b1b336f5-d683-9f85-5789-bc76ce397062" style="opacity:0" class="hero_license_container">
          <div class="hero_license">
            <div class="hero_license_icons"><img src="/assets/landings/images/european_union.svg" loading="lazy" alt="" class="image-54"><img src="/assets/landings/images/es.svg" loading="lazy" width="201" alt="" class="image-53"><img src="/assets/landings/images/bde_icon_color.svg" loading="lazy" width="201" alt="" class="icon_bank"></div>
            <div class="hero_license_text">Empresa registrada en el Banco de España con número D803. <a href="https://clientebancario.bde.es/pcb/es/blog/registros-del-banco-de-espana.html" target="_blank" class="know_more">Saber más</a>
            </div>
          </div>
        </div>
      </div>
      <div class="media-spotlight">
        <div class="text-block-82">Hablan de nosotros</div>
        <div class="div-block-144"><img src="/assets/landings/images/rtve.svg" loading="lazy" width="78" alt="" class="image-23"><img src="/assets/landings/images/business.svg" loading="lazy" width="110" alt="" class="image-23"></div>
      </div>
    </div>
  </div>
</div>

<currenciespopup [selectedCurrencyIsoCode]="purchaseFlowHelperService.selectedCurrency" (onCurrencySelected)="onCurrencySelected($event)" #currenciespopup></currenciespopup>
<cryptospopup [selectedCrypto]="purchaseFlowHelperService.selectedCrypto" (onCryptoSelected)="purchaseFlowHelperService.selectCrypto($event)" #cryptospopup></cryptospopup>
